import { useMutation } from '@tanstack/react-query';
import { getRegistrationInfo } from '../requests';

export function useGetRegistrationInfo() {
  const mutation = useMutation({
    mutationFn: (state: string) => getRegistrationInfo(state),
  });

  return {
    getRegistrationInfo: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
